export const JAVASCRIPT = "JAVASCRIPT";
export const SHOPIFY = "SHOPIFY";
export const PRESTASHOP = "PRESTASHOP";
export const WOOCOMERCE = "WOOCOMERCE";
export const MAGENTO = "MAGENTO";
